import { render, staticRenderFns } from "./project-details.vue?vue&type=template&id=39390f82&scoped=true&"
import script from "./project-details.vue?vue&type=script&lang=js&"
export * from "./project-details.vue?vue&type=script&lang=js&"
import style0 from "./project-details.vue?vue&type=style&index=0&id=39390f82&prod&scoped=true&lang=css&"
import style1 from "./project-details.vue?vue&type=style&index=1&id=39390f82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39390f82",
  null
  
)

export default component.exports